import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import {
  Box,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { getUserId } from "../utlis/tokenUtils";
import TocIcon from "@mui/icons-material/Toc";
import apiClient from "../utlis/apiClient";

import PaginationComponent from "../Common/PaginationComponent";

const ManageMaterial = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const navigate = useNavigate();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#325c67",
      color: theme.palette.common.white,
      padding: "10px",
      verticalAlign: "top",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: "10px !important",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#f3f3f3",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(`/api/product/get-all-products`);
      console.log(response.data);
      if (Array.isArray(response.data.data)) {
        setProducts(response.data.data);
      } else {
        console.error("Unexpected data format:", response.data.data);
        setProducts([]);
      }
    } catch (error) {
      console.error("Error fetching Products: ", error);
      setProducts([]);
    } finally {
      setLoading(false); // Set loading to false when fetch completes
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleClick = (product) => {
 
    navigate("/UpdateMaterial", {
      state: {
        productData: product,
        productPK: product.PK,
        productSK: product.SK,
      },
    });
  };




  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Header />
      <SubHeader />
      <Grid
        container
        sx={{ flexGrow: 1, marginTop: "-80px", padding: 0 }}
        spacing={6}
      >

        <Grid item xs={12} md={11}>
          <Box
            sx={{
              minHeight: "calc(100vh - 112px)",
              backgroundColor: "white",
              padding: 2,
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              marginLeft: "150px",
            }}
          >
            <Grid
              container
              alignItems="center"
              spacing={2}
              justifyContent="space-between"
            >
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  Material Details
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
               
                  component={Link}
                  to="/AddMaterial"
                  size="small"
                >
                  Add Material
                </Button>
              </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ marginTop: 4 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>MaterialName</StyledTableCell>
                    <StyledTableCell>Grade</StyledTableCell>
                    <StyledTableCell>Dimension</StyledTableCell>
                    <StyledTableCell>Material Id</StyledTableCell>
                    <StyledTableCell>Quantity</StyledTableCell>
                    <StyledTableCell>Comments</StyledTableCell>
                    {/* <StyledTableCell>Action</StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={13} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : products.length > 0 ? (
                    products
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((product, index) => (
                      <StyledTableRow key={product.PK}>
                        <StyledTableCell>{product.MaterialName}</StyledTableCell>
                        <StyledTableCell>{product.Grade}</StyledTableCell>
                        <StyledTableCell> {product.Dimension}</StyledTableCell>
                        <StyledTableCell> {product.MaterialId}</StyledTableCell>
                        <StyledTableCell> {product.Quantity}</StyledTableCell>
                        <StyledTableCell>{product.Comments}</StyledTableCell>
                        {/* <StyledTableCell>
                          <TocIcon
                            sx={{ cursor: "pointer" }}
                            onClick={() => handleClick(product)}
                          />
                        </StyledTableCell> */}
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={13} align="center">
                        There Are No Material Data.
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
              <PaginationComponent count={products.length} page={page} rowsPerPage={rowsPerPage} onPageChange={handleChangePage} />
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ManageMaterial;